import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import JobDestroyDialog from '../../dialogs/job.destroy';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const job = useConnect('job.byId', {
    id: config.params.jobId
  });

  if (job.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <JobDestroyDialog
      job={job}
      onCancel={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['job'] });
      }}
    />
  );
};
